import { render, staticRenderFns } from "./UpdateNews.vue?vue&type=template&id=46905b0f&scoped=true"
import script from "./UpdateNews.vue?vue&type=script&lang=js"
export * from "./UpdateNews.vue?vue&type=script&lang=js"
import style0 from "./UpdateNews.vue?vue&type=style&index=0&id=46905b0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46905b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46905b0f')) {
      api.createRecord('46905b0f', component.options)
    } else {
      api.reload('46905b0f', component.options)
    }
    module.hot.accept("./UpdateNews.vue?vue&type=template&id=46905b0f&scoped=true", function () {
      api.rerender('46905b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/notify/UpdateNews.vue"
export default component.exports